module.exports = __webpack_public_path__ + "img/Molecule_Thinking.91dccec1.gif";